<div class="header-container">
  <div>
    <mat-form-field>
      <mat-label>Search for a plan</mat-label>
      <input #drugManagementPlanSearch matInput [formControl]="drugManagementPlanFormControl"
             data-qa="qa-input"
             (input)="onKeyUpFilterData('name')">
    </mat-form-field>
  </div>
  <div class="header-spacer"></div>
  <div>
    <button [routerLink]="'/pharmacy-management/add-drug-management-plan'" mat-raised-button color="accent">
      <mat-icon>add</mat-icon>
      Add Plan
    </button>
  </div>
</div>

<div *ngIf="!drugManagementPlanDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="drugManagementPlanDataSource" class="mat-elevation-z8 table-container">
  
  <table mat-table multiTemplateDataRows [dataSource]="drugManagementPlanDataSource" matSort
         #drugManagementplanSort="matSort" (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editDmpTooltip="matTooltip"
                  matTooltip="EDIT Drug Management Plan" (click)="editEntry($event, row.drugManagementPlanId)">edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteDmpTooltip="matTooltip"
                  matTooltip="DELETE Drug Management Plan" (click)="deleteEntry($event, row.drugManagementPlanId)">
          delete
        </mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="drugManagementPlanId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.drugManagementPlanId}}</td>
    </ng-container>
    
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Name</th>
      <td *matCellDef="let row" mat-cell> {{row.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="policy">
      <th *matHeaderCellDef mat-header-cell> Policy</th>
      <td *matCellDef="let row" mat-cell> {{displayObjectNameIfNotNull(row.policy)}}</td>
    </ng-container>
    
    <ng-container matColumnDef="product">
      <th *matHeaderCellDef mat-header-cell> Product</th>
      <td *matCellDef="let row" mat-cell> {{displayObjectNameIfNotNull(row.product)}}</td>
    </ng-container>
    
    <ng-container matColumnDef="startDate">
      <th *matHeaderCellDef mat-header-cell> Start Date</th>
      <td *matCellDef="let row" mat-cell> {{row.startDate | date: dateFormat}}</td>
    </ng-container>
    
    <ng-container matColumnDef="endDate">
      <th *matHeaderCellDef mat-header-cell> End Date</th>
      <td *matCellDef="let row" mat-cell> {{endDateDisplay(row.endDate) | date: dateFormat}}</td>
    </ng-container>
    
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="drugManagementPlanDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == drugManagementPlanExpandedRow ? 'expanded' : 'collapsed'">
          <b>Administrator: </b>{{displayObjectNameIfNotNull(row.administrator)}}<br>
          <b>Payer: </b>{{displayObjectNameIfNotNull(row.payer)}}<br>
          <b>Policy Holder: </b>{{displayObjectNameIfNotNull(row.policyHolder)}}<br>
          <b>Policy Holder Group: </b>{{displayObjectNameIfNotNull(row.policyHolderGroup)}}<br>
          <b>Reinsurer: </b>{{displayObjectNameIfNotNull(row.reinsurer)}}<br>
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="drugManagementPlanDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: drugManagementPlanDisplayedColumns;" class="row"
        [class.expanded-row]="drugManagementPlanExpandedRow == row"
        (click)="drugManagementPlanExpandedRow = drugManagementPlanExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  
  </table>
  
  <mat-paginator #drugManagementPlanPaginator (page)="pageChanged($event)"
                 [length]="drugManagementPlanTableControl.length" [pageSize]="drugManagementPlanTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="drugManagementPlanTableControl.pageSizeOptions">
  </mat-paginator>

</div>
